import React, { useEffect, useRef } from "react";
import "./App.scss";
import "primereact/resources/themes/mdc-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
// -- Packages
import { observer } from "mobx-react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// -- Prime React
import { Toast } from "primereact/toast";
// -- Local
import { ServiceSearch } from "./pages/ServiceSearch/ServiceSearch";
import IconProvider from "./utils/IconProvider";
import { AppHeader } from "./components/appHeader/AppHeader";
import AppStore from "./AppStore";

export const App: React.FC = observer(() => {
   const getBasename = (path: string) => path.substr(0, path.lastIndexOf("/"));
   IconProvider.load();

   const toast = useRef(null);
   useEffect(() => {
      AppStore.toast = toast.current;
   }, [toast]);

   return (
      <BrowserRouter basename={getBasename(window.location.pathname)}>
         <div className="App">
            <div className="header-wrapper">
               <AppHeader />
            </div>
            <div className="nav-wrapper"></div>
            <div className="container">
               <Switch>
                  <Route exact path="/" component={ServiceSearch} />
               </Switch>
            </div>
         </div>
         <Toast ref={toast} />
      </BrowserRouter>
   );
});
